/**
 * 封装ajax
 * 
 */

import axios from 'axios'
import Qs from 'qs'
import { Message } from 'element-ui'; // 引入Message弹框组件
import local from '@/utils/local'
import router from "@/router/index"

let severUrl;
// 环境的切换
if (process.env.NODE_ENV == 'development') {
    // severUrl = 'http://39.105.61.38:8803';
    // severUrl = 'http://192.168.2.47:8803';
   
	severUrl = 'https://beerapi.mufengweilai.com';
    // severUrl = 'https://5726735cp6.oicp.vip';

} else if (process.env.NODE_ENV == 'debug') {

} else if (process.env.NODE_ENV == 'production') {
    severUrl = '/api';
}

//默认请求api
axios.defaults.baseURL = severUrl
// axios.defaults.baseURL = 'http://47.107.129.103:8085'


// 请求拦截器
axios.interceptors.request.use(config =>{
  let token =local.get("t_k") || ""
  if(token){
      config.headers.token=token;
  }
  return config
})
//响应拦截器

axios.interceptors.response.use( response =>{
 if(response.data.hasOwnProperty("code")&&response.data.hasOwnProperty("msg")){
     let { code,msg } =response.data;
     if (code === 3003) {  // 如果code等于0 统一弹出成功提示框
        Message.error('此账号在另一地登录，请重新登录')
        router.push("/login");
        local.clear()
    }else if(code==3001){
        Message.error('身份已过期，请重新登录')
        router.push("/login");
        local.clear()
    }else if(code!=200){
        Message.error(msg)
    } 
      
 }
   return response;
})

//get请求 和post请求
const req={
 get(url,params={}){
     return new Promise( (resolve,reject)=>{
         axios.get(url,{params})
         .then(response=>{resolve(response.data)})
         .catch(err=>{reject(err)})

     })
 },
 post(url,params={}){
    return new Promise( (resolve,reject)=>{
        axios.post(url,params)
        .then(response=>{resolve(response.data)})
        .catch(err=>{reject(err)})
    })
},
put(url,params={}){
    return new Promise( (resolve,reject)=>{
        axios.put(url,params)
        .then(response=>{resolve(response.data)})
        .catch(err=>{reject(err)})
    })
},

}

export default req;









